
export function roundedDistance(distance) {
  return Math.round(distance * 100) / 100;
}
